/**
 * @fileoverview Copy-to-clipboard helpers for HelpContactInformation rows.
 */

export const COPY_I18N_KEYS = {
  COPIED: "components.helpContactInformation.copied",
  COPY_TO_CLIPBOARD: "components.helpContactInformation.copyToClipboard",
};

export const getCopyButtonAriaLabel = (copiedField, fieldName, t) =>
  copiedField === fieldName
    ? t(COPY_I18N_KEYS.COPIED)
    : t(COPY_I18N_KEYS.COPY_TO_CLIPBOARD);
